<template>
  <div class="progressbar">
    <v-progress-circular
        indeterminate
        color="primary"
        :size="100"
        :width="7"
    ></v-progress-circular>
  </div>
</template>

<script>
export default  {
  name: "progressbar",
}
</script>



<style>
.progressbar {
  position: fixed;
  z-index: 99;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  left: 0;
  width: 100vw;
  height: 100vh;
  opacity: 0.5;
}
</style>